<template>
  <button
    class="btn px-0 font-weight-bold"
    :class="{ 'btn-link': sortable }"
    @click.prevent="doSort">
    <slot>{{ label }}</slot>
    <template v-if="sortable && sort === property">
      <i
        v-if="dir && dir.toUpperCase().startsWith('ASC')"
        class="fa fa-caret-up"/>
      <i
        v-if="dir && dir.toUpperCase().startsWith('DESC')"
        class="fa fa-caret-down"/>
    </template>
  </button>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: undefined
    },

    property: {
      type: String,
      default: undefined
    },

    sort: {
      type: String,
      default: undefined
    },

    dir: {
      type: String,
      default: undefined
    },

    sortable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    isNotEmpty () {
      console.log('this.$slots.default', this.$slots.default);
      return this.$slots.default || this.label;
    }
  },

  methods: {
    doSort() {
      if (this.sortable) {
        this.$emit('action', this.property);
      }
    }
  }
};
</script>
